import { SelectOptionModel } from '@/domain/model/select'

export const getFilterOption = (
  input: string,
  option: SelectOptionModel | undefined
) => {
  const label = String(option?.label ?? '').toLocaleLowerCase()

  return label.includes(input.toLocaleLowerCase())
}
